import styled from 'styled-components';

export const StyledSettings = styled.section`
  ${({ theme }) => theme.mixins.views}
`;
